import { siteConfig } from "../config/site";

export default function Gallery() {
  const imgs = siteConfig.images.gallery;

  return (
    <section id="gallery" data-testid="gallery-section" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 sm:px-10">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-12">
          <div>
            <span className="inline-block text-[0.7rem] tracking-[0.35em] uppercase text-[color:var(--yicel-violet)] font-semibold">
              Galería
            </span>
            <h2 className="mt-3 font-display text-4xl sm:text-5xl text-ink">
              Construyendo el camino
            </h2>
          </div>
          <p className="max-w-sm text-sm text-[color:var(--yicel-muted)]">
            Pedazos del proceso — sesiones, escenarios y madrugadas escribiendo.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6">
          {imgs.map((src, i) => (
            <div
              key={i}
              data-testid={`gallery-item-${i}`}
              className={`relative overflow-hidden rounded-3xl group cursor-pointer ${
                i % 5 === 0 ? "row-span-2 aspect-[3/4]" : "aspect-square"
              }`}
              style={{
                transform: `rotate(${i % 2 === 0 ? "-0.8deg" : "0.6deg"})`,
              }}
            >
              <img
                src={src}
                alt={`Galería ${i + 1}`}
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#B2A4FF]/30 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
